import capitalize from 'lodash/capitalize'
import { CROP_TYPE } from '../../utils/cropUtils.consts'

// Per-crop-type count keys, generated from CROP_TYPE to stay in sync with
// getCropsDistribution() in orderAnalytics.js.
const CROP_COUNT_KEYS = Object.values(CROP_TYPE).map(
  (cropType: string) => `${capitalize(cropType)} Cropped Photos Count`
)

export const MERGE_TRACKING_DATA_STRATEGIES = {
  // Add numeric values across partials, rounded to an integer
  sum: [
    'Order Items Count',
    'Order Tiles',
    'Photo Count',
    'Will Be Upscaled Count',
    ...CROP_COUNT_KEYS,
    'Smart Crop Adjusted Count',
    'Crop Fit Photos Count',
    'Content Tiles Count',
    'Art Tiles Count',
    'Wall Preview Tiles Count',
    'Cart Upsell Tiles Count',
    'Total Face Count',
    'Tiles With Faces Count',
    'Face Detection Failed Count',
    'Total Faces Below Crop Threshold',
  ],
  // Add numeric values across partials, rounded to 2 decimal places
  sumAndRound: [
    'USD Revenue',
    'Order Revenue',
    'USD Shipping Cost',
    'ArtPhoto USD Revenue',
    'AI Templates USD Revenue',
  ],
  // Union arrays across partials, deduping values
  union: [
    'Tile Sizes',
    'Tile Materials',
    'Source',
    'Content Tiles Set',
    'Art Tiles',
    'Gift Card IDs',
    'Cart Upsell IDs',
  ],
  // Take the value from the first partial only. The gift-card / credit fields
  // are group-level — the same checkout summary is spread onto every sub-order,
  // so each partial holds the identical value and summing would multiply it by
  // the number of sub-orders.
  first: [
    'Local ID',
    'Credits Used',
    'Credit Redeemed',
    'Credit Redeemed USD',
    'Gift Card Count',
    'Gift Card Credits Balance',
    'Gift Card Credits Redeemed',
  ],
  // Values that should be identical for every sub-order in the group. Conflicts
  // are reported instead of picking one.
  sameValue: [
    'Currency',
    'Destination Country',
    'Gift Note Added',
    'Shipping Option',
    'Express Shipping Selected',
    'Express Shipping Offered',
    'Priority Shipping Selected',
    'Priority Shipping Offered',
    'User Email',
    'Hash Email',
    'Who Is It For',
    'Checkout Id',
    'Payment Method',
    'Attribution Survey',
  ],
  // Boolean/"True" flags emitted only by the matching product branch.
  anyTrue: [
    'Book Order',
    'Photos Order',
    'Art Collection Order',
    'AI Templates Order',
    'Non 8x8 Order',
    'Non 8x8 Single Tiles',
    'Non 8x8 Photo Wall',
  ],
  // Product-branch metadata that should appear at most once in a mixed group.
  // The photo-book branch already aggregates over every book in its sub-order.
  firstPresent: [
    'Centerpiece Name',
    'Books Count',
    'Is Creative Cover',
    'Creative Cover Location',
    'Is AI Generated Designed Cover',
    'Title Used',
    'Designed Cover ID',
    'Designed Cover Name',
    'Designed Cover Tags',
    'Page Style',
    'Book Caption Percentage',
    'Book Pages With Captions',
    'Book Total Pages',
  ],
}
